import {
  ClinicRoleTypeModel,
  IClinicRoleTypeModel,
} from './ClinicRoleTypeModel';
import { IModel, ModelRecord, Model } from './Model';
import { defaultTo } from 'lodash';

export interface IClinicRoleModel extends IModel {
  clinicRoleId: number;
  name: string | undefined;
  displayName: string | undefined;
  abbreviation: string | undefined;
  desiredMaxUsers: number;
  isVetAssistant: boolean;
  isDVM: boolean;
  clinicRoleTypeId: number;
  sortOrder: number;
  clinicRoleType: IClinicRoleTypeModel;
}

export class ClinicRoleModel
  extends Model
  implements ModelRecord<IClinicRoleModel>
{
  clinicRoleId: number;
  name: string | undefined;
  displayName: string | undefined;
  abbreviation: string | undefined;
  desiredMaxUsers: number;
  isVetAssistant: boolean;
  isDVM: boolean;
  clinicRoleTypeId: number;
  sortOrder: number;
  clinicRoleType: ClinicRoleTypeModel;

  constructor(params?: Partial<IClinicRoleModel>) {
    super(params);
    this.clinicRoleId = defaultTo(params?.clinicRoleId, 0);
    this.name = defaultTo(params?.name, '');
    this.displayName = defaultTo(params?.displayName, '');
    this.abbreviation = defaultTo(params?.abbreviation, '');
    this.desiredMaxUsers = defaultTo(params?.desiredMaxUsers, 0);
    this.isVetAssistant = defaultTo(params?.isVetAssistant, false);
    this.isDVM = defaultTo(params?.isDVM, false);
    this.clinicRoleTypeId = defaultTo(params?.clinicRoleTypeId, 0);
    this.sortOrder = defaultTo(params?.sortOrder, 0);
    this.clinicRoleType = params?.clinicRoleType
      ? new ClinicRoleTypeModel(params?.clinicRoleType)
      : new ClinicRoleTypeModel();
  }
}
